'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialJavascriptOutline = function IoSocialJavascriptOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.5 8.1h-3.7v15.3c0 2.4-0.5 3.9-1.4 5-0.8 1.1-2 1.6-3.7 1.6-0.7 0-1.4-0.1-2-0.2l-0.3 2.4c0.9 0.1 2 0.3 2.9 0.3 2.7 0 4.6-0.6 5.9-2 1.5-1.4 2.3-3.7 2.3-7v-15.4z m1.3-1.2v16.6c0 7.6-3.9 10.3-9.5 10.3-1.4 0-3.1-0.3-4.3-0.7l0.6-4.8c0.8 0.3 1.9 0.5 3.1 0.5 2.4 0 3.8-1.2 3.8-5.4v-16.5h6.3z m13.5 0.6c-2.6 0-4.8 0.7-6.4 2-1.4 1.2-2.1 2.8-2.1 4.7 0 1.6 0.5 2.8 1.6 4 1.1 1.1 2.6 2 4.8 2.8 1.8 0.6 2.9 1.2 3.7 1.9 0.9 0.9 1.4 1.8 1.4 3 0 1.2-0.5 2.4-1.5 3.1-1 0.7-2.2 1.1-3.8 1.1-2.2 0-4.1-0.6-5.5-1.2l-0.5 2.5c1.4 0.6 3.4 1.1 5.6 1.1 3 0 5.5-0.7 7-2.1 1.4-1.3 2.1-3 2.1-4.9 0-1.7-0.3-2.8-1.3-3.9s-2.4-2.1-4.5-2.9c-3-1.2-5.6-2.2-5.6-4.9 0-1.1 0.5-2.2 1.4-2.9 0.9-0.7 2.1-1 3.6-1 1.8 0 3.3 0.4 4.4 0.9l0.8-2.5c-1.5-0.5-3.3-0.8-5.2-0.8z m0-1.2c3 0 5.1 0.5 6.7 1.2l-1.5 5c-1-0.5-2.7-1.3-5.2-1.3s-3.8 1.2-3.8 2.6c0 1.7 1.5 2.4 4.9 3.7 4.5 1.7 6.6 4.1 6.6 8 0 4.4-3.3 8.3-10.4 8.3-3 0-5.6-0.8-7.1-1.7l1.2-4.9c1.5 0.8 3.8 1.6 6.3 1.6 2.7 0 4.1-1.1 4.1-2.9 0-1.7-1.2-2.6-4.3-3.7-4.3-1.6-7.3-4.1-7.3-8 0-4.5 3.8-8 9.8-8z' })
        )
    );
};

exports.default = IoSocialJavascriptOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-javascript-outline.js
// module id = 2454
// module chunks = 0